import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
import OfferModal from '../../Component/Modal/OfferModal';
import { viewOffer } from '../../Redux/Slice/Offer';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon';
import HttpClient from '../../utils/HttpClient';
import toast from 'react-hot-toast';
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal';
import { Link, useNavigate } from 'react-router-dom';
import partnerPurchaseHistory from '../../Images/partnerPurchaseHistory.jpg'
import './Offer.css'


// buttonstyle


const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const format1 = "DD-MM-YYYY, h:mm a"
const ViewManageOffer = () => {
    const [OfferStatus, setOfferStatus] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [AllData, setAllData] = useState([])
    const [expiryOffers, setexpiryOffers] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [OfferID, setOfferID] = useState("");
    const dispatch = useDispatch()
    const { ViewOffersData } = useSelector((state) => state.app)
    const navigate = useNavigate()



    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            // width: "9.4rem"
        },



        {
            name: 'Partner Name',
            selector: row => row.partnerName,
            width: "12rem"
        },

        {
            name: 'Offer Type',
            selector: row => row.offerType,
            width: "9.4rem"
        },
        {
            name: 'Reddeming Points',
            selector: row => row.reddemingPoints,
            width: "9.4rem"
        },
        {
            name: 'Voucher No',
            selector: row => row.voucherNo,
            width: "9.4rem"
        },
        {
            name: 'Voucher Validity(Days)',
            selector: row => row.voucherValidity,
            width: "9.4rem"
        },
        {
            name: 'Offer Validity(Days)',
            selector: row => row.offerValidity,
            width: "9.4rem"
        },
        {
            name: 'Offer Created',
            selector: row => row.createdOn,
            width: "9.4rem"
        },
        {
            name: 'Offer Expiry',
            selector: row => row.offerExpiryDate,
            width: "9.4rem"
        },

        {
            name: 'View',

            cell: (row) => (
                <i className="fa-solid fa-eye "

                    onClick={() => handleView(row.id)}
                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '15px' }}></i>
            ),
        },
        {
            name: 'Action',
            selector: row => row.action,
            width: "9.4rem"
        },
        {
            name: 'Purchase Details',
            selector: row => row.History,
            width: "9.4rem"
        }



    ];

    const ViewOffersTableData = () => {
        setIsLoading(true);
        let apiData = []
        let expiredOffers = []
        if (ViewOffersData.length > 0) {
            setIsLoading(false);
            const currentDate = moment();
            // apiData = ViewOffersData?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
            // current offers
            apiData = ViewOffersData?.filter(item => moment(item?.offerExpiryDate).isAfter(currentDate))?.map((item, i) => ({
                id: item?._id,
                sl: i + 1,
                partnerName: item?.partnerName,
                offerType: item?.offerType,
                reddemingPoints: item?.reddemingPoints,
                voucherNo: item?.voucherNo,
                voucherValidity: item?.voucherValidity,
                offerValidity: item?.offerValidity,
                createdOn: moment(item?.createdOn).format(format1),
                offerExpiryDate: moment(item?.offerExpiryDate).format(format1),
                action: <EditDeleteIcon
                    onClickEdit={(e) => handleEdit(item)}
                    onClickDelete={(e) => handleDelete(item?._id)}
                />,
                History: <div><Link to={`/partner-purchase-history/${item?.partnerId}`}><img src={partnerPurchaseHistory} style={{ width: "35px", height: "35px", cursor: "pointer" }} title="Purchase History" /></Link>
                </div>,

            }))
            // expired offers
            expiredOffers = ViewOffersData?.filter(item => moment(item?.offerExpiryDate).isBefore(currentDate))?.map((item, i) => ({
                id: item?._id,
                sl: i + 1,
                partnerName: item?.partnerName,
                offerType: item?.offerType,
                reddemingPoints: item?.reddemingPoints,
                voucherNo: item?.voucherNo,
                voucherValidity: item?.voucherValidity,
                offerValidity: item?.offerValidity,
                createdOn: moment(item?.createdOn).format(format1),
                offerExpiryDate: moment(item?.offerExpiryDate).format(format1),
                action: <EditDeleteIcon
                    // onClickEdit={(e) => handleEdit(item)}
                    onClickDelete={(e) => handleDelete(item?._id)}
                />,
                History: <div><Link to={`/partner-purchase-history/${item?.partnerId}`}><img src={partnerPurchaseHistory} style={{ width: "35px", height: "35px", cursor: "pointer" }} title="Purchase History" /></Link>
                </div>,

            }))

        }
        else {
            setIsLoading(false)
        }
        setAllData(apiData);
        setexpiryOffers(expiredOffers)
    }
    // edit offer
    const handleEdit = (item) => {
        navigate("/offers", { state: item })
    }

    //Delete  Offer

    const handleDelete = async (id) => {


        const del = async () => {
            setIsLoading(true)
            const res = await HttpClient.requestData("offer/" + id, "DELETE", {})
            if (res && res?.status) {
                setIsLoading(false)
                toast.success('Offer Deleted Successfully')
                dispatch(viewOffer())
            }
            else {
                toast.e('Something went wrong! Please try again later.');
                setIsLoading(false)
            }
        }
        DeleteConfirmModal(del)

    }

    //MODAL VIEW
    const handleView = async (id) => {
        setOfferID(id);
        setIsModalOpen(true);
    }

    useEffect(() => {
        ViewOffersTableData()
    }, [ViewOffersData])

    useEffect(() => {
        dispatch(viewOffer())
    }, [])

    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <button className='button-92' onClick={() => setOfferStatus(true)}>Current Offers</button>
                    <button className='button-91' onClick={() => setOfferStatus(false)}>Expiry Offers</button>
                    {OfferStatus ? <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        MANAGE CURRENT OFFERS
                    </div> :
                        <div
                            style={headLineStyle}
                            className="page-headline"
                        >
                            MANAGE EXPIRED OFFERS
                        </div>}



                    <form>

                        <div>

                            {OfferStatus ? <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded "
                                customStyles={customStyles}
                            /> :
                                <DataTable
                                    columns={columns}
                                    data={expiryOffers}
                                    pagination
                                    striped
                                    className=" rounded "
                                    customStyles={customStyles}
                                />}
                        </div>
                    </form>
                </section>
                <OfferModal
                    isOpen={isModalOpen}
                    closeModal={() => setIsModalOpen(false)}
                    id={OfferID}
                />
            </div>

        </div>
    )
}

export default ViewManageOffer